import { TweenLite } from "gsap";
import { gsap } from "gsap/all"
import { getMoveIndex, isElHasProperty, getStyleProp } from "../chunks";
import propNames from "../propNames";

let isHovered = false;
let cursorTarget = null;
let moveHandler = null;
let outHandler = null;

const moveCursor = (e, cursor, props, parallaxSpeed) => {
  // If element is not hovered
  if (!isHovered) {
    gsap.to(cursor, props.transitionSpeed, {
      x: e.clientX - props.radius / 2,
      y: e.clientY - props.radius / 2,
    });
    // If eleemnt is hovered
  } else {
    const borderRadius = Number(
      window.getComputedStyle(cursorTarget).borderRadius.slice(0, -2)
    );
    // For "LIFT" mode
    if (isElHasProperty(cursorTarget, propNames.lift)) {
      TweenLite.to(cursorTarget, props.transitionSpeed, {
        x: getMoveIndex(
          e.clientX,
          cursorTarget.getBoundingClientRect().left,
          cursorTarget.clientWidth,
          parallaxSpeed.target
        ),
        y: getMoveIndex(
          e.clientY,
          cursorTarget.getBoundingClientRect().top,
          cursorTarget.clientHeight,
          parallaxSpeed.target
        ),
        scale: 1.1,
        boxShadow: getStyleProp("--ghost-shadow"),
      });
      TweenLite.to(cursor, props.transitionSpeed, {
        filter: "blur(8px)",
        x:
          cursorTarget.getBoundingClientRect().left +
          (e.clientX -
            cursorTarget.getBoundingClientRect().left -
            cursorTarget.clientWidth / 2) /
            parallaxSpeed.cursor,
        y:
          cursorTarget.getBoundingClientRect().top +
          (e.clientY -
            cursorTarget.getBoundingClientRect().top -
            cursorTarget.clientHeight / 2) /
            parallaxSpeed.cursor,
        backgroundImage: `radial-gradient(circle at ${
          e.clientX - cursorTarget.getBoundingClientRect().left
        }px ${
          e.clientY - cursorTarget.getBoundingClientRect().top
        }px, rgba(255,255,255,0.4), rgba(255,255,255,0))`,
      });
      // For default "PARALLAX" mode
    } else {
      TweenLite.to(cursor, props.transitionSpeed, {
        x:
          cursorTarget.getBoundingClientRect().left -
          (isElHasProperty(cursorTarget, propNames.noPadding)
            ? null
            : props.hoverPadding) +
          (isElHasProperty(cursorTarget, propNames.noParallax)
            ? 0
            : (e.clientX -
                cursorTarget.getBoundingClientRect().left -
                cursorTarget.clientWidth / 2) /
              parallaxSpeed.cursor),
        y:
          cursorTarget.getBoundingClientRect().top -
          (isElHasProperty(cursorTarget, propNames.noPadding)
            ? null
            : props.hoverPadding) +
          (isElHasProperty(cursorTarget, propNames.noParallax)
            ? 0
            : (e.clientY -
                cursorTarget.getBoundingClientRect().top -
                cursorTarget.clientHeight / 2) /
              parallaxSpeed.cursor),
        borderRadius:
          borderRadius *
          (isElHasProperty(cursorTarget, propNames.noPadding) ? 1 : 1.5),
        width:
          cursorTarget.clientWidth +
          (isElHasProperty(cursorTarget, propNames.noPadding)
            ? null
            : props.hoverPadding * 2),
        height:
          cursorTarget.clientHeight +
          (isElHasProperty(cursorTarget, propNames.noPadding)
            ? null
            : props.hoverPadding * 2),
      });
      // For "NO PARALLAX" property
      if (!isElHasProperty(cursorTarget, propNames.noParallax)) {
        TweenLite.to(cursorTarget, props.transitionSpeed, {
          x: -getMoveIndex(
            e.clientX,
            cursorTarget.getBoundingClientRect().left,
            cursorTarget.clientWidth,
            parallaxSpeed.target
          ),
          y: -getMoveIndex(
            e.clientY,
            cursorTarget.getBoundingClientRect().top,
            cursorTarget.clientHeight,
            parallaxSpeed.target
          ),
        });
      }
    }
  }
};

const handleMouseOver = (e, cursor, props, parallaxSpeed) => {
  isHovered = true;
  cursorTarget = e.target;
  const borderRadius = Number(
    window.getComputedStyle(cursorTarget).borderRadius.slice(0, -2)
  );

  if (isElHasProperty(cursorTarget, propNames.lift)) {
    cursor.classList.add("c-cursor-lift_active");
    TweenLite.to(cursor, props.transitionSpeed, {
      borderRadius: borderRadius,
      width: cursorTarget.clientWidth,
      height: cursorTarget.clientHeight,
      scale: 1.1,
    });
  } else {
    cursor.classList.add("c-cursor_active");
  }
};

const handleMouseOut = (e, cursor, props, parallaxSpeed) => {
  isHovered = false;
  cursor.classList.remove("c-cursor_active");
  cursor.classList.remove("c-cursor-lift_active");

  TweenLite.to(cursor, props.transitionSpeed, {
    x: e.clientX - props.radius / 2,
    y: e.clientY - props.radius / 2,
    width: props.radius,
    height: props.radius,
    borderRadius: "100px",
    scale: 1,
    backgroundImage: "none",
    filter: "blur(0px)",
  });
  TweenLite.to(cursorTarget, props.transitionSpeed, {
    x: 0,
    y: 0,
    scale: 1,
    boxShadow: "0 7px 15px rgba(0,0,0,0.0)",
  });
};

function moveEvent(cursor, props, parallaxSpeed, e) {
  // console.log('eventtt', cursor)
  moveCursor(e, cursor, props, parallaxSpeed);
}

function outEvent(cursor, props, parallaxSpeed, e) {
  handleMouseOut(e, cursor, props, parallaxSpeed);
}

const contextMode = (
  cursor,
  props,
  interactElements
) => {
  const parallaxSpeed = {
    cursor: props.parallaxIndex,
    target: props.parallaxIndex * 1.5,
  };

  // Event listeners
  moveHandler = moveEvent.bind(null, cursor, props, parallaxSpeed);
  outHandler = outEvent.bind(null, cursor, props, parallaxSpeed);

  document.addEventListener("mousewheel", outHandler);
  document.addEventListener("mousemove", moveHandler);

  interactElements.forEach((item) => {
    item.addEventListener("mouseenter", (e) => {
      handleMouseOver(e, cursor, props, parallaxSpeed);
    });
  });

  interactElements.forEach((item) => {
    item.addEventListener("mouseleave", (e) => {
      handleMouseOut(e, cursor, props, parallaxSpeed);
    });
  });
};

const contextModeDestroy = (
    cursor,
    props,
    interactElements
) => {
  // console.log(interactElements)

  if (moveHandler) {
    document.removeEventListener("mousemove", moveHandler);
  }

  if (outHandler) {
    document.removeEventListener("mousewheel", outHandler);
  }

  interactElements.forEach((item) => {
    item.removeEventListener("mouseenter", (e) => {
      handleMouseOver(e);
    });
  });
  interactElements.forEach((item) => {
    item.removeEventListener("mouseleave", (e) => {
      handleMouseOut(e);
    });
  });
};

export { contextModeDestroy }
export default contextMode;
